// extracted by mini-css-extract-plugin
export default {"intro":"IntroSection_intro__mbVH1","intro__aside":"IntroSection_intro__aside__YsKnr","intro__btn":"IntroSection_intro__btn__OtEKt","animation":"IntroSection_animation__8ecip"};